module.exports = __webpack_public_path__ + "static/media/imgGuidelines.17756252.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgGuidelines.png
// module id = 81
// module chunks = 0